import React from 'react';

interface IAcceptIcon extends React.HTMLProps<SVGElement> {
    className?: string;
    stroke?: string;
    strokeWidth?: string;
    onClick?: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

const AcceptIcon = (props: IAcceptIcon) => {
    return (
        <svg
            onClick={props.onClick}
            className={props.className || ''}
            role="img"
            aria-label="Selected"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 13"
            fill="none"
        >
            <path
                d="M1 5.64286L5.875 11L13 1"
                stroke={props.stroke || '#FFFFFF'}
                strokeWidth={props.strokeWidth || '2'}
            />
        </svg>
    );
};

export default AcceptIcon;
